'use client';
import { ReactComponent } from './info-xs.svg';
export const InfoIconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=info-xs.js.map